/**
 * The per-container band of the Day timeline: colour rail, the container's
 * chip, its experiment line and the right-aligned summary with one
 * behavioural fact. Its groups and lists are not repeated here (user,
 * 19/10/2026): every drop row names its list, and "Lists in use today"
 * lists them all.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { usd } from '@/lib/reporting-currency';

import type { DayPlanContainerRow } from '../../drop-generator.types';
import { ContainerChip } from '../shared/ContainerChip';
import { ExperimentLine } from '../shared/experiment/ExperimentLine';
import { bandTint } from './timeline-grid';

interface Props {
  container: DayPlanContainerRow;
  /** One behavioral fact for the summary, e.g. "ramp 5 × 500 → 2 × 1,000". */
  fact: string | null;
}

export const TimelineBand: FC<Props> = ({ container, fact }) => {
  const summary = [
    `${container.totals.drops} drops`,
    `${container.totals.sms.toLocaleString('en-US')} SMS`,
    container.totals.cost !== null ? usd(container.totals.cost, 0) : null,
  ]
    .filter(Boolean)
    .join(' · ');
  return (
    <div className="flex min-h-[38px] items-stretch">
      <span className="w-1 shrink-0 rounded-sm" style={{ backgroundColor: container.color }} />
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-4 gap-y-1 px-4 py-2" style={{ backgroundColor: bandTint(container.color) }}>
        <ContainerChip name={container.name} color={container.color} />
        <ExperimentLine experiment={container.experiment} />
        <span className="ml-auto whitespace-nowrap font-mono text-[11.5px] tabular-nums text-muted-foreground" title={fact ?? undefined}>
          {summary}
        </span>
      </div>
    </div>
  );
};
